<template>
  <SetPassword
    :title="title"
    :submit-btn-title="submitBtnTitle"
    :message="message"
  />
</template>

<script>
import SetPassword from "@/components/password/SetPassword";

export default {
  components: { SetPassword },
  name: "PasswordWelcome",

  computed: {
    title() {
      return this.$t("AUTH.WELCOME.TITLE");
    },

    message() {
      return this.$t("AUTH.WELCOME.MESSAGE");
    },

    submitBtnTitle() {
      return this.$t("AUTH.WELCOME.BUTTON");
    }
  }
};
</script>
